// extracted by mini-css-extract-plugin
export default {"FavouriteList":"favourite-list_FavouriteList__C+luv"};